import PlainPage from './PlainPage';

export default PlainPage;
